import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useTheme } from "../context/ThemeContext";
import { useCart } from "../context/CartContext";

export function PaymentSuccess() {
  const t = useTheme();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [tx, setTx] = useState(null);
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setTx(data);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("[payment] status poll failed:", err?.response?.status || err?.message);
      }
      attempts += 1;
      if (attempts < 8) timer = setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
    return () => { if (timer) clearTimeout(timer); };
  }, [sessionId, clear]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-success">
      {status === "checking" && <p className="opacity-75">Confirming your payment…</p>}
      {status === "paid" && (
        <>
          <div className="text-[11px] tracking-[0.4em] uppercase" style={{ color: t.primary }}>Order Confirmed</div>
          <h1 className="mt-3 text-5xl" style={{ color: t.text }}>Thank you</h1>
          <p className="mt-6 text-lg italic" style={{ fontFamily: "'Cormorant Garamond', serif" }}>"You look good — and that means you'll conquer everything ahead."</p>
          {tx && <p className="mt-6 opacity-80">Order total: ${Number(tx.amount).toFixed(2)} {tx.currency?.toUpperCase()}</p>}
          <p className="mt-2 text-sm opacity-70">A confirmation email will arrive shortly. Estimated delivery: 3–5 business days.</p>
          <Link to={`/`} className={`mt-10 inline-block px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`}>Back to home</Link>
        </>
      )}
      {status !== "checking" && status !== "paid" && (
        <>
          <h1 className="text-3xl" style={{ color: t.text }}>Payment status: {status}</h1>
          <Link to={`/cart`} className={`mt-8 inline-block px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnOutline}`}>Back to cart</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  const t = useTheme();
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel">
      <h1 className="text-4xl" style={{ color: t.text }}>Payment cancelled</h1>
      <Link to={`/cart`} className={`mt-8 inline-block px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`}>Return to cart</Link>
    </div>
  );
}
